import { Text, Weight } from 'components'

import CloseIcon from 'assets/close-icon.svg?react'
import { CurrencyMetadata } from 'indices-list'
import React from 'react'
import {
  CoinIcon,
  HeaderTitle,
  ItemContent,
  ListItem,
  ScrollList,
  ScrollTitleBox,
  SelectArrow,
  SelectItemSubText,
  SelectItemText,
  SelectWrapper,
  SelectorText,
  StyledCloseButton,
  StyledTitle,
} from './styled'

interface SelectProps {
  list: CurrencyMetadata[]
  width?: string
  onChange: (value: React.SetStateAction<boolean>) => void
  isOpened: boolean
  selectedAsset: CurrencyMetadata
  selectAsset: (asset: CurrencyMetadata) => void
}

export const AssetsSelect: React.FC<SelectProps> = ({
  list,
  isOpened,
  onChange,
  selectedAsset,
  selectAsset,
  width,
}) => {
  const isList = list.length > 1

  const close = () => onChange(false)

  const toggleList = () => {
    if (isList) {
      onChange(!isOpened)
    }
  }

  const handlerSelectItem = (item: CurrencyMetadata) => {
    selectAsset(item)
    onChange(!isOpened)
  }

  return (
    <SelectWrapper active={isOpened} width={width}>
      <StyledTitle onClick={toggleList} active={isOpened} pointed={isList}>
        <HeaderTitle>
          <CoinIcon src={selectedAsset.icon} />
          <SelectorText type={selectedAsset.symbol.length > 6 ? 'four' : 'two'}>
            {selectedAsset.symbol}
          </SelectorText>
        </HeaderTitle>
        {isList && <SelectArrow size={8} />}
      </StyledTitle>
      {isOpened && (
        <ScrollList>
          <ScrollTitleBox>
            <Text type={'p'} weight={Weight.Medium}>
              Select a token
            </Text>
            <StyledCloseButton onClick={close} icon={CloseIcon} />
          </ScrollTitleBox>

          {list.map((item) => (
            <ListItem key={item.symbol} onClick={() => handlerSelectItem(item)}>
              <ItemContent>
                <CoinIcon src={item.icon} />
                <SelectItemText>{item.symbol}</SelectItemText>
                <SelectItemSubText>{item.name}</SelectItemSubText>
              </ItemContent>
            </ListItem>
          ))}
        </ScrollList>
      )}
    </SelectWrapper>
  )
}
